import React, { useState } from "react";
import "../styles/InviteModal.css";

const InviteModal = ({ isOpen, onClose, doctorName, doctorEmail }) => {
  const [patientName, setPatientName] = useState("");
  const [patientEmail, setPatientEmail] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);

  const handleInvite = async (e) => {
    e.preventDefault();
    setStatus(null);
    try {
      const response = await fetch("https://directory.virtualtriage.ai/doctors/invite/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          doctor_email: doctorEmail,
          patient_email: patientEmail,
          patient_name: patientName,
          message,
        }),
      });
      const data = await response.json();
      if (data.status) {
        setStatus("Invitation sent successfully!");
        setPatientName("");
        setPatientEmail("");
        setMessage("");
      } else {
        setStatus("Failed to send invitation.");
      }
    } catch (error) {
      setStatus("Error sending invitation.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="invite-modal">
        <h2>Invite Practitioner</h2>
        <p>
          This practitioner{doctorName ? ` (${doctorName})` : ""} has not joined Virtual Triage yet. You can easily invite them by filling out your information and submitting the form. We will notify them that you have invited them to join Virtual Triage.
        </p>
        <form onSubmit={handleInvite}>
          <input
            type="text"
            placeholder="Your Full Name"
            value={patientName}
            onChange={(e) => setPatientName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Your Email"
            value={patientEmail}
            onChange={(e) => setPatientEmail(e.target.value)}
            required
          />
          <textarea
            placeholder="Invitation Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <button type="submit">Send Invite</button>
        </form>
        {status && <div style={{ marginTop: 10, color: status.includes("success") ? "green" : "red" }}>{status}</div>}
      </div>
    </div>
  );
};

export default InviteModal;
